import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import ConfirmDelete from '../../../components/ConfirmDelete'
import ButtonsGrid from '../../../components/ButtonsGrid'
import Table from '../../../components/Table'
import auth from '../../../utils/auth'
import cfg from '../../../utils/config'
import axios from 'axios'
import helper from '../../../utils/helper'

class Grid extends Component {
    state = {
        data: [],
        loading: true,
        redirectToEdit: false,
        table: null
    }

    getData = (state) => {
        this.setState({ loading: true })
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/lns/planos/?limit=' + state?.lineCount + state.filter

        if (state.url) {
            url = state.url
        }

        axios.get(url, config_me).then((res) => {
            this.setState({
                loading: false,
                data: res.data.results,
                count: res.data.count,
                next: res.data.next,
                previous: res.data.previous
            })
        })
    }

    deletar = () => {
        let requestArray = []
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        this.setState({ loading: true, enableDeletar: false, enableEditar: false })

        this.state?.table?.state.selected.map((value, index) =>
            requestArray.push(axios.delete(cfg.base_api_url + cfg.api_v2 + `/${userInfo.empresa}/lns/planos/${value}/`, config_me))
        )

        axios.all(requestArray).then(axios.spread((acct, perms) => {
            this.state?.table?.fetch()
            this.state?.table?.unselect()
        }))
    }

    editar = () => {
        let toGo = "/lns/planos/" + this.state?.table?.state.selected?.[0] + "/editar/"
        let from = { pathname: toGo }
        this.setState({ redirectToEdit: from })
    }

    convertDate = (date) => new Date(Date.parse(date)).toLocaleDateString('pt-BR',
        { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
    )

    render() {
        const { redirectToEdit, table } = this.state
        if (redirectToEdit) {
            return <Redirect to={redirectToEdit} />
        }

        const columns = [
            {
                Header: 'Nome',
                Accessor: 'nome'
            }, 
            {
                Header: 'Valor',
                Accessor: 'valor',
                Cell: (original) => {
                    let valor = helper.formatMoney(original.valor)
                    return <span>{valor}</span>
                }
            }, 
            {
                Header: 'Qtd. Clientes',
                Accessor: 'quantidade_clientes'
            }, 
            {
                Header: 'Tipo',
                Accessor: 'tipo'
            }, 
            {
                Header: 'Criado em',
                Accessor: 'data_criado',
                Cell: (original) => {
                    return <span>{this.convertDate(original.data_criado)}</span>
                }
            }, 
            {
                Header: 'Atualizado em',
                Accessor: 'data_atualizado',
                Cell: (original) => {
                    return <span>{this.convertDate(original.data_atualizado)}</span>
                }
            }
        ]

        return (
            <>
                <div>
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            <h4>Cadastro de Planos</h4>
                            <div className="gray-background">
                                <i className="las la-file-invoice-dollar la-2x"></i>
                            </div>
                        </span>
                    </div>
                    <div className="hdv-btn-group">
                        <ButtonsGrid 
                            route="/lns/planos"
                            buttons={[
                                {
                                    method: "post",
                                    button: <Link to={'/lns/planos/novo'}><button className="hdv-btn-forms hdv-btn-green ">Novo</button></Link>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={table?.state.enableEditar ? this.editar : null} className={"hdv-btn-forms hdv-btn-yellow " + (table?.state.enableEditar ? "" : "hdv-btn-disable")}>Editar</button>
                                },

                                {
                                    method: "delete",
                                    button: <ConfirmDelete enabled={table?.state.enableDeletar} action={this.deletar} />
                                }
                            ]}
                        />
                    </div>

                    <Table
                        checkbox
                        data={this.state.data}
                        loading={this.state.loading}
                        count={this.state.count}
                        next={this.state.next}
                        previous={this.state.previous}
                        columns={columns}
                        onFetchData={this.getData}
                        onUpdate={(table) => this.setState({ table })}
                    />
                </div>
            </>
        )
    }
}

export default Grid